/**
 * Branding font catalogue — the fixed set of heading/body font-stack pairings a
 * firm can choose in the Branding Studio (`fontPair`). A static UI lookup table,
 * NOT per-tenant data.
 *
 * Relocated here from `lib/fake-data/admin-v2.ts` (2026-06-25) so BOTH the
 * Studio AND the white-label runtime (`branding-runtime.ts`) can import it
 * from a non-fake-data module — the runtime needs the same `fontPair → stacks`
 * mapping to apply a firm's typography app-wide, and importing fake-data is
 * lint-blocked. Single source of truth for the font choices.
 *
 * `TONE_MAP` (the greeting-tone templates) lived here until 2026-08-23, when
 * Paul removed the Voice control from the Studio: a firm chooses its colours,
 * logo and typography, not the words the product says. The Studio was its only
 * consumer, so the table is gone. The `tone` FIELD survives on the branding
 * types and in stored overlays on purpose — nothing writes it any more, and
 * nothing reads it, so old documents keep loading without a backend change.
 */

export type FontPairKey = 'news-inter' | 'tiempos-soehne' | 'editorial-apercu';

export interface FontPair {
  headingStack: string;
  bodyStack: string;
  displayLabel: string;
  sub: string;
}

export const FONT_MAP: Record<FontPairKey, FontPair> = {
  'news-inter': {
    headingStack: `'Newsreader','Times New Roman',serif`,
    bodyStack: `'Inter',sans-serif`,
    displayLabel: 'Newsreader · Inter',
    sub: 'Editorial serif italic + neutral sans',
  },
  'tiempos-soehne': {
    headingStack: `Georgia,'Times New Roman',serif`,
    bodyStack: `'Inter',sans-serif`,
    displayLabel: 'Tiempos · Söhne',
    sub: 'Modern serif body + grotesque',
  },
  'editorial-apercu': {
    headingStack: `'Newsreader',serif`,
    bodyStack: `'Inter',sans-serif`,
    displayLabel: 'Editorial New · Apercu',
    sub: 'High-contrast display + humanist sans',
  },
};
